export default ()=>{
  return(`

    .MarginTopXS {
      margin-top: 3px;
    }

    .MarginRightXS {
      margin-right: 3px;
    }

    .MarginBottomXS {
      margin-bottom: 3px;
    }

    .MarginLeftXS {
      margin-left: 3px; 
    }

    .MarginTopNegativeS {
      margin-top: -13px;
    }

    .MarginTopS {
      margin-top: 13px;
    }

    .MarginRightS {
      margin-right: 13px;
    }

    .MarginBottomS {
      margin-bottom: 13px;
    }

    .MarginLeftS {
      margin-left: 13px; 
    }

    .MarginTopM {
      margin-top: 19px;
    }

    .MarginRightM {
      margin-right: 19px;
    }

    .MarginBottomM {
      margin-bottom: 19px;
    }

    .MarginLeftM {
      margin-left: 19px; 
    }

    .MarginTopL {
      margin-top: 29px;
    }

    .MarginRightL {
      margin-right: 29px;
    }

    .MarginBottomL {
      margin-bottom: 29px;
    }

    .MarginLeftL {
      margin-left: 29px; 
    }
  `)
}
